// used in notifications-list.component.html

// Angular
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ContentChange } from "ngx-quill";

// Services/Types/Helpers
import { Notification } from "cli-types";
import { FormHelper } from "#core/helpers";

@Component({
    selector: "reply-pm",
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./reply-pm.component.html",
    styleUrls: [
        "../../notifications.component.scss",
        "./reply-pm.component.scss",
    ],
    standalone: false
})
export class ReplyPmComponent implements OnInit {
    @Input()
    notification?: Notification;

    @Output()
    reply = new EventEmitter<Notification>();

    @Output()
    cancel = new EventEmitter<any>();

    pmForm?: UntypedFormGroup;

    working = false;

    // Toolbar configuration
    modules = {
        toolbar: [
            ["bold", "italic", "underline", "strike"], // toggled buttons

            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["link"],
            [{ align: [] }],

            ["clean"], // remove formatting button
        ],
    };

    constructor(private fb: UntypedFormBuilder, private formHelper: FormHelper) {}

    ngOnInit() {
        this.initForm();
    }

    initForm() {
        this.pmForm = this.fb.group({
            body: [
                "",
                [
                    Validators.required,
                    this.formHelper.noQuillEditorWhitespaceValidator,
                ],
            ],
            title: [
                "",
                [
                    Validators.required,
                    Validators.minLength(2),
                    Validators.maxLength(128),
                ],
            ],

            // Automatically set, not on form.
            toUserID: [null],
            inReplyToNoticeID: [null],
        });
        if (this.notification) {
            let reTitle = this.notification.title;
            if (!this.notification.title.includes("Re:")) {
                reTitle = "Re:" + this.notification.title;
            }
            this.pmForm.patchValue({
                title: reTitle,
                toUserID: this.notification.author.userGUID,
                inReplyToNoticeID: this.notification.noticeID,
            });
        }
    }

    sendReply() {
        if (this.pmForm?.valid) {
            this.working = true;
            this.reply.emit(this.pmForm.value);
        }
    }

    onClickCancel() {
        this.initForm();
        this.cancel.emit();
    }

    setBody(editor: ContentChange) {
        // Force form to recalculate.
        if (this.pmForm) {
            this.pmForm.updateValueAndValidity();
        }
    }
}
